export default __webpack_public_path__ + "static/media/manageoffer.5d1c366a.svg";